import { Host, HostCommonDetails } from '@/models/Host';
import { Node } from '@/models/Node';
import { ProSettings } from '@/models/ProSettings';
import { Tag } from '@/models/Tags';
import { User } from '@/models/User';

export const NULL_HOST: Host = {
  id: '',
  verbosity: 0,
  firewallinuse: '',
  version: '',
  name: '',
  os: '',
  debug: false,
  isstatic: false,
  isstaticport: false,
  listenport: 0,
  localrange: '',
  mtu: 0,
  interfaces: [],
  defaultinterface: '',
  endpointip: '',
  endpointipv6: '',
  publickey: '',
  macaddress: '',
  nodes: [],
  isdefault: false,
  nat_type: 'public',
  persistentkeepalive: 0,
  autoupdate: false,
};

export const NULL_HOST_COMMON_DETAILS: HostCommonDetails = {
  name: '',
  version: '',
  endpointip: '',
  endpointipv6: '',
  publickey: '',
  os: '',
  listenport: 0,
  isstaticendpoint: false,
  isstaticport: false,
  mtu: 0,
  interfaces: [],
  macaddress: '',
  firewallinuse: '',
};

export const NULL_NODE: Node = {
  id: '',
  hostid: '',
  address: '',
  address6: '',
  localaddress: '',
  interface: '',
  macaddress: '',
  lastmodified: 0,
  expdatetime: 0,
  lastcheckin: 0,
  lastpeerupdate: 0,
  network: '',
  networkrange: '',
  networkrange6: '',
  pendingdelete: false,
  isegressgateway: false,
  isingressgateway: false,
  ingressdns: '',
  ingressmtu: 0,
  ingresspersistentkeepalive: 0,
  metadata: '',
  egressgatewayranges: [],
  egressgatewaynatenabled: false,
  failovernode: '',
  dnson: false,
  islocal: false,
  server: '',
  defaultacl: '',
  connected: false,
  failover: false,
  relayedby: '',
  relaynodes: [],
  autoupdate: false,
  isrelay: false,
  isrelayed: false,
  isinternetgateway: false,
  is_fail_over: false,
  failed_over_by: '',
  fail_over_peers: [],
  internetgw_node_id: '',
  inet_node_req: {
    inet_node_client_ids: undefined,
  },
  additional_rag_ips: [],
  is_static: false,
  is_user_node: false,
  static_node: {
    clientid: '',
    description: '',
    privatekey: '',
    publickey: '',
    network: '',
    address: '',
    address6: '',
    ingressgatewayid: '',
    ingressgatewayendpoint: '',
    lastmodified: 0,
    enabled: false,
    ownerid: '',
    internal_ip_addr: '',
    internal_ip_addr6: '',
    dns: '',
    extraallowedips: [],
    tags: {},
  },
  tags: {},
};

export const NULL_NETWORK_PROSETTINGS: ProSettings = {
  defaultaccesslevel: 0,
  defaultusernodelimit: 0,
  defaultuserclientlimit: 0,
  allowedusers: [],
  allowedgroups: [],
};

export const NULL_NODE_ID = '00000000-0000-0000-0000-000000000000';

export const NULL_TAG: Tag = {
  id: '',
  tag_name: '',
  network: '',
  tagged_nodes: [],
  used_by_count: 0,
  created_by: '',
  created_at: new Date(),
};

export const mockNewUserWithGroup: User = {
  username: 'mock-user',
  user_group_ids: { all: {} },
  platform_role_id: 'mock-role',
  network_roles: { mockNetworkId: { mockRoleId: {} } },
  isadmin: false,
  issuperadmin: false,
  remote_gw_ids: null,
  auth_type: 'basic_auth',
};

export const mockNewUserWithoutGroup: User = {
  username: 'mock-user',
  user_group_ids: {},
  platform_role_id: 'mock-role',
  network_roles: { mockNetworkId: { mockRoleId: {} } },
  isadmin: false,
  issuperadmin: false,
  remote_gw_ids: null,
  auth_type: 'oauth',
};
